"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var decentraland_ui_1 = require("decentraland-ui");

var NetworkCheck_1 = __importDefault(require("../NetworkCheck"));

var disabledStyle = {
  opacity: 0.5,
  cursor: 'not-allowed',
  transform: 'none'
};

var NetworkButton = /*#__PURE__*/function (_react_1$default$Pure) {
  _inherits(NetworkButton, _react_1$default$Pure);

  function NetworkButton() {
    _classCallCheck(this, NetworkButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(NetworkButton).apply(this, arguments));
  }

  _createClass(NetworkButton, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          network = _a.network,
          onClick = _a.onClick,
          rest = __rest(_a, ["network", "onClick"]);

      return react_1.default.createElement(NetworkCheck_1.default, {
        network: network
      }, function (isEnabled) {
        var props = isEnabled ? {
          onClick: onClick
        } : {
          style: disabledStyle
        };
        return react_1.default.createElement(decentraland_ui_1.Button, Object.assign({}, rest, props));
      });
    }
  }]);

  return NetworkButton;
}(react_1.default.PureComponent);

exports.default = NetworkButton;